import React, {useState, useEffect} from "react";
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios'
import { useForm } from "react-hook-form";
import { modePaiementDefaultAll } from "app/modePaiementDefaultAll";

const ModePaiementList = (props) => {
    const t = useTranslate()
    const { register, formState: { errors }, handleSubmit, control } = useForm();
    const [validButton,setValidButton] = useState(false)
    const [apiError,setApiError] = useState(false)
    const [success,setSuccess] = useState(false)
    
    let sectionPaiements =new Array;
    if (props.from=='company') {
        if(props.company.modepaiement_disponible){
            props.company.modepaiement_disponible.forEach(sectionPaiement=>
                sectionPaiements.push(sectionPaiement)    
            )
        }
    }
    else{
        if(props.other_company.modepaiement_disponible){
            props.other_company.modepaiement_disponible.forEach(sectionPaiement=>
                sectionPaiements.push(sectionPaiement)    
            )
        }
    }

    
    const onSubmit = async (data) => {
        setValidButton(true)
        setApiError(false)
        setSuccess(false)
        const response  = await axios.put(process.env.REACT_APP_API_URL+props.url, {
            modepaiement_disponible: data.modepaiement
        }).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                setApiError(messageError)
            }
            else{
                setSuccess(true)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            if(error.response==undefined){
                setApiError(t('unknowError'))
            }
            else if(error.response.status==403){
                setApiError(t('forbiddenGeneral'))
            }
            else {
                setApiError(t('unknowError'))
            }
        })
        setValidButton(false)
        setTimeout(() => {
            setSuccess(false)
        }, 1000)
    }

    function splitArrayIntoTwo(arr) {
        //Fonction qui permet de diviser l'aray des modes de paiement en 2 array égaux
        const middleIndex = Math.ceil(arr.length / 2);
        const firstHalf = arr.slice(0, middleIndex);
        const secondHalf = arr.slice(middleIndex);
        return [firstHalf, secondHalf];
    }

    const modepaiement = (props.from=='company') ? props.company.modepaiement : props.other_company.company.modepaiement
    let allOtherModePayment = modepaiement.map(value=>{
        if(value.name){
            return value.name
        }else{
            return value
        }
    })
    
    let allPaymentMode = [...modePaiementDefaultAll,...allOtherModePayment]
    const [allPaymentMode1, allPaymentMode2] = splitArrayIntoTwo(allPaymentMode);

    return(
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="form-group col-12 col-lg-6" style={{marginBottom:0}}>
                    {allPaymentMode1.map((modePaie,ind)=>(
                        <div key={ind} className="form-check form-switch">
                            <input type="checkbox" className="form-check-input" value={modePaie} defaultChecked={sectionPaiements.includes(modePaie)} {...register("modepaiement[]")}/>
                            <label title="" className="form-check-label">{t(modePaie) ? t(modePaie) : modePaie}</label>
                        </div>
                    ))}
                </div>
                <div className="form-group col-12 col-lg-6" style={{marginBottom:0}}>
                    {allPaymentMode2.map((modePaie,ind)=>(
                        <div key={ind} className="form-check form-switch">
                            <input type="checkbox" className="form-check-input" value={modePaie} defaultChecked={sectionPaiements.includes(modePaie)} {...register("modepaiement[]")}/>
                            <label title="" className="form-check-label">{t(modePaie) ? t(modePaie) : modePaie}</label>
                        </div>
                    ))}
                </div>
            </div>
            {(apiError) ? <div className="alert alert-danger mt-3" dangerouslySetInnerHTML={{ __html: apiError }}></div> : false}
            {(success) ? <div className="alert alert-success mt-3">{t('successOperation')}</div> : false}
            <button disabled={validButton} className="btn btn-primary mt-3">
                {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
            </button>
        </form>
    )
}

export default ModePaiementList;